import { Injectable } from '@angular/core';
import { IgenomicsState } from '@ispm/core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { IFindingsState } from '../../../store/findings.reducer';
import { initActionCreator, updateActionCreator } from '../../../constants/findings.constants';
import { getActiveRecord } from '@ispm/workflow/utils/store.utils';
import {ObjectUtils} from "@ispm/shared/utils/Object.utils";

@Injectable()
export class FindingsActionCreatorService {
  private store: Store<IFindingsState>;

  constructor(store: Store<IgenomicsState>) {
    this.store = store.select('tests', 'findings') as any;
  }

  public init() {
    this.store.dispatch(initActionCreator(null));

  }

  public update(key: keyof(IFindingsState), value: any) {
    this.store.dispatch(updateActionCreator({ key, value}));
  }

  public getState(...properties: string[]) {
    const store = this.store.select(state => ObjectUtils.walk(state,properties.toString().replace(",",".")));
    return store.flatMap(state => getActiveRecord(state));
  }

}
